import { ReactNode } from 'react'
import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'

export interface BreadcrumbItem {
    label: string
    link?: string
}

export interface RenderLinkProps {
    to: string
    children: ReactNode
    'data-testid'?: string
}

export interface PageBreadcrumbsProps {
    items: BreadcrumbItem[]
    /** Render function for linked breadcrumb items. If not provided, all items render as plain text. */
    renderLink?: (props: RenderLinkProps) => ReactNode
}

const separator = (
    <Typography component="h1" variant="h2" noWrap sx={{ color: 'inherit' }}>
        /
    </Typography>
)

const PageBreadcrumbs = ({ items, renderLink }: PageBreadcrumbsProps) => {
    return (
        <Breadcrumbs sx={{ color: 'inherit' }} separator={separator} aria-label="breadcrumb">
            {items.map((item, index) => {
                const textElement = (
                    <Typography
                        key={`breadcrumb-${item.label}`}
                        data-testid={`breadcrumb-${index}-text`}
                        component="h1"
                        variant="h2"
                        sx={{ color: 'inherit', wordBreak: 'break-word' }}
                    >
                        {item.label}
                    </Typography>
                )

                if (item.link && renderLink && index < items.length - 1) {
                    return (
                        <span key={`breadcrumb-${item.label}-link`}>
                            {renderLink({
                                to: item.link,
                                children: textElement,
                                'data-testid': `breadcrumb-${index}-link`,
                            })}
                        </span>
                    )
                }

                return textElement
            })}
        </Breadcrumbs>
    )
}

export default PageBreadcrumbs
